<template>
    <div class="hidden"></div>
</template>

<script>
import axios from 'axios';

export default {
    props:['cookieconsent'],
    watch: {
        $route(to, from) {
            this.pageView(to.path)
            if (this.$store.state.stepSelectedIndex == 1) {
                const data = {
                    contentType: this.$store.state.selected.enrolable
                        .enrolableCategory,
                    routeName: this.$route.path
                };
                axios
                    .post("/api/fb-api-viewcontent", data)
                    .then(res => res.data);
            }
            if (this.$store.state.stepSelectedIndex == 4) {
                axios
                    .post("/api/fb-api-initcheckout", { routeName: this.$route.path })
                    .then(res => res.data);
            }
        }
    },
    methods: {
        pageView(routeName){
            axios.post("/api/fb-api-page-view", { routeName: routeName })
                .then(res => res.data);
        },
        getCookie(cname) {
            let name = cname + "=";
            let ca = document.cookie.split(";");
                for (let i = 0; i < ca.length; i++) {
                    let c = ca[i];
                while (c.charAt(0) == " ") {
                    c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                    return c.substring(name.length, c.length);
                }
                }
            return "";
        },
        setCookie(cname, cvalue, exdays) {
            const d = new Date();
            d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
            let expires = "expires=" + d.toUTCString();
            document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
        },
        eraseCookie(name) {
            document.cookie = name+'=; Max-Age=-99999999;';
        }
    },
    created() {
        if (!this.cookieconsent) {
            this.eraseCookie('_fbp')
        }else if(this.getCookie('_fbp') == '' && this.cookieconsent){
            this.setCookie('_fbp', 'fb.1.'+new Date().getTime()+'.'+Math.floor((Math.random() * 10000000000) + 1), 60);
        }
        this.pageView(this.$route.path);
    },
};
</script>
